import { Component } from '@angular/core';

@Component({
  selector: 'app-home-component',
  imports: [],
  standalone: true,
  templateUrl: './home-component.html',
  styleUrl: './home-component.scss',
})
export class HomeComponent {}
